import styled from 'styled-components';
import { COLORS, device, FONTS } from '../../constants';
import { SectionContainer } from '../aboutUs/styles';
import { Title, Text, VerticalBox, Box } from '../../components';
import { useTranslation } from 'react-i18next';

export const ContactUs = () => {
  const { t } = useTranslation();
  return (
    <SectionContainer>
      <Box>
        <VerticalBox>
          <SectionTextContainer>
            <FormContainer>
              <Header>
                <Title
                  title={t('screen.contact.text')}
                  color={COLORS.BLACK_TITLE}
                  size={60}
                  lineHeight={70}
                  isAnimated={true}
                />
                <TextContainer>
                  <Text
                    text={t('screen.contact.form_title')}
                    size={22}
                    lineHeight={28}
                    isAnimated={true}
                  />
                </TextContainer>
              </Header>
              <FormWrapper>
                <iframe
                  title={'innowise-form'}
                  src="https://innowisepl-test.inno.ws/framemobiledepartment/"
                  allow="microphone"
                  width="100%"
                  height="100%"
                />
              </FormWrapper>
            </FormContainer>
            <NextMoveContainer>
              <Title
                title={t('screen.contact.card.title')}
                color={COLORS.FOOTER_BACKGROUND}
                size={36}
                lineHeight={46}
              />
              <NextMoveTextContainer>
                <NextMoveTextSection>
                  <Number>1</Number>
                  <NextMoveTextWrapper>
                    <Text
                      text={t('screen.contact.card.step_1')}
                      margin="7px 0"
                      fontFamily={FONTS.SUBTITLE}
                      weight={400}
                      size={16}
                      lineHeight={24}
                    />
                  </NextMoveTextWrapper>
                </NextMoveTextSection>
                <NextMoveTextSection>
                  <Number>2</Number>
                  <NextMoveTextWrapper>
                    <Text
                      text={t('screen.contact.card.step_2')}
                      margin="7px 0"
                      fontFamily={FONTS.SUBTITLE}
                      weight={400}
                      size={16}
                      lineHeight={24}
                    />
                  </NextMoveTextWrapper>
                </NextMoveTextSection>
                <NextMoveTextSection>
                  <Number>3</Number>
                  <NextMoveTextWrapper>
                    <Text
                      text={t('screen.contact.card.step_3')}
                      margin="7px 0"
                      fontFamily={FONTS.SUBTITLE}
                      weight={400}
                      size={16}
                      lineHeight={24}
                    />
                  </NextMoveTextWrapper>
                </NextMoveTextSection>
                <NextMoveTextSection>
                  <Number>4</Number>
                  <NextMoveTextWrapper>
                    <Text
                      text={t('screen.contact.card.step_4')}
                      margin="7px 0"
                      fontFamily={FONTS.SUBTITLE}
                      weight={400}
                      size={16}
                      lineHeight={24}
                    />
                  </NextMoveTextWrapper>
                </NextMoveTextSection>
              </NextMoveTextContainer>
            </NextMoveContainer>
          </SectionTextContainer>
        </VerticalBox>
      </Box>
    </SectionContainer>
  );
};

const SectionTextContainer = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr minmax(500px, 539px);
  align-items: start;
  @media screen and ${device.xl} {
    display: flex;
    gap: 80px;
    align-items: flex-start;
  }
  @media screen and ${device.lg} {
    gap: 40px;
    flex-direction: column;
    align-items: center;
  }
  @media screen and ${device.sm} {
    gap: 0;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  @media screen and ${device.xl} {
    > span {
      font-size: 40px;
      line-height: 50px;
    }
  }
  @media screen and ${device.lg} {
    gap: 10px;
    > div > p {
      font-size: 17px;
      line-height: 21px;
    }
  }
  @media screen and ${device.md} {
    > div > p {
      text-align: center;
    }

    > span {
      font-size: 30px;
      line-height: 36px;
      text-align: center;
    }
  }
  @media screen and ${device.sm} {
    margin-bottom: 5px;
    > span {
      font-size: 22px;
      line-height: 24px;
      text-align: center;
      min-height: 0;
    }

    > div > p {
      font-size: 16px;
      line-height: 20px;
    }
  }
`;

const FormWrapper = styled.div`
  max-width: 700px;
  height: 1005px;
  iframe {
    border: none;
  }
  @media screen and ${device.sm} {
    height: 1100px;
  }
`;

const TextContainer = styled.div`
  max-width: 600px;
`;

const HeaderText = styled.p`
  margin: 0;
  padding: 0;
  font-family: ${FONTS.TITLE};
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  @media screen and ${device.lg} {
    gap: 10px;
  }
`;

const NextMoveContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  max-width: 500px;
  background-color: ${COLORS.BG_NEXT_MOVES};
  padding: 60px 47px;
  margin-right: 21px;
  position: relative;

  &:before {
    content: '';
    display: inline-block;
    position: absolute;
    border: 1px dashed ${COLORS.BORDER_NEXT_MOVES};
    width: 100%;
    height: 100%;
    top: 19px;
    left: 21px;
    z-index: -1;
  }

  @media screen and ${device.lg} {
    padding: 40px 27px;
    max-width: 350px;
    > span {
      font-size: 25px;
      line-height: 30px;
    }

    gap: 20px;
  }
  @media screen and ${device.md} {
    max-width: 100%;
  }
  @media screen and ${device.sm} {
    margin-right: 5px;
    &:before {
      top: 5px;
      left: 5px;
    }
  }
`;

const NextMoveTextContainer = styled.div`
  position: relative;
  z-index: 1;
  overflow: hidden;
  @media screen and ${device.md} {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 30px;
  }
  @media screen and ${device.sm} {
    display: block;
  }
`;

const NextMoveTextSection = styled.div`
  display: grid;
  grid-template-columns: 40px minmax(350px, 380px);
  column-gap: 28px;
  min-height: 55px;
  position: relative;

  &:nth-child(1) {
    margin-bottom: 28px;
  }

  &:nth-child(2) {
    margin-bottom: 26px;
  }

  &:nth-child(3) {
    margin-bottom: 24px;
  }

  &:before {
    content: '';
    display: inline-block;
    width: 1px;
    min-height: 100000000vh;
    background-color: ${COLORS.FOOTER_BACKGROUND};
    position: absolute;
    left: 20px;
    bottom: 25px;
    z-index: -1;
  }

  @media screen and ${device.md} {
    display: flex;
    flex-direction: column;
    align-items: center;
    &:before {
      width: calc(100% + 30px);
      min-height: 0;
      max-height: 1px;
      position: absolute;
      left: 50%;
      top: 20px;
    }

    &:nth-child(4):before {
      width: 0;
    }
  }
  @media screen and ${device.sm} {
    display: grid;
    grid-template-columns: 40px 1fr;
    align-items: start;
    &:before {
      content: '';
      display: inline-block;
      width: 1px;
      min-height: 100000000vh;
      max-height: 100000000vh;
      background-color: ${COLORS.FOOTER_BACKGROUND};
      position: absolute;
      left: 20px;
      bottom: 25px;
      top: auto;
      z-index: -1;
    }

    &:nth-child(4):before {
      width: 1px;
    }
  }
`;

const NextMoveTextWrapper = styled.div`
  max-width: 380px;
  @media screen and ${device.lg} {
    max-width: 100%;
    > h4 {
      font-size: 14px;
      line-height: 16px;
    }
  }
`;

const Number = styled.div`
  align-selft: start;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid ${COLORS.FOOTER_BACKGROUND};
  color: ${COLORS.FOOTER_BACKGROUND};
  font-size: 18px;
  font-family: ${FONTS.SUBTITLE};
  line-height: 28px;
  font-weight: 700;
  background: white;
`;
